import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "development-economics-theories-models-indian-policy",
  title: "Development Economics Notes: Key Theories, Growth Models & Indian Policy Framework",
  description: "Comprehensive study notes — Classical Development Theories, Modern Growth Theory, Poverty Measurement, and Indian Policy Framework.",
  category: "subject-explainers",
  authorSlug: "uday-kumar",
  pubDate: "2026-08-20",
  tags: ["development-economics", "growth-models", "indian-policy"],
  readMinutes: 13,
  heroEyebrow: "Subject Explainer · Development",
};

export const Body = () => {
  return (
    <article className="prose lg:prose-xl">
      <h1>{meta.title}</h1>
      <p>Development economics bridges economic theory and real-world policy, analyzing how nations grow and improve living standards.</p>

      <h2>Classical Development Theories</h2>
      <p><strong>Lewis Dual-Sector Model:</strong> Explains structural transformation from a traditional, subsistence agricultural sector to a modern, capitalist industrial sector, driven by transferring surplus labor.</p>
      <p><strong>Rostow's Stages of Growth:</strong> Five stages: traditional society, preconditions for take-off, take-off, drive to maturity, and age of high mass consumption.</p>
      <p><strong>Big Push &amp; Balanced vs. Unbalanced Growth:</strong> The Big Push theory argues for simultaneous investment across multiple sectors to overcome coordination failures. Unbalanced growth (Hirschman) advocates investing in key leading sectors.</p>

      <h2>Modern Growth Theory</h2>
      <p><strong>Endogenous Growth:</strong> Unlike Solow, endogenous models (e.g., Romer's R&amp;D model) explain long-run growth through internal factors like innovation and human capital accumulation.</p>

      <h2>Poverty &amp; Inequality Measurement</h2>
      <p><strong>Inequality:</strong> Lorenz Curve graphically shows income distribution. The Gini coefficient is the ratio of the area between the line of equality and the Lorenz curve to the total area under the line of equality.</p>
      <p><strong>Poverty:</strong> Headcount Ratio (percentage of population below poverty line), Poverty Gap Index (depth of poverty), and Sen Index (combines incidence, depth, and distribution among the poor).</p>

      <h2>HDI &amp; MPI Composition</h2>
      <p>The Human Development Index (HDI) combines health (life expectancy), education (years of schooling), and standard of living (GNI per capita). The Multidimensional Poverty Index (MPI) includes broader deprivations across health, education, and living standards.</p>

      <h2>India's Policy Framework</h2>
      <p><strong>Five Year Plans &amp; NITI Aayog:</strong> Transition from centralized planning to NITI Aayog's cooperative federalism approach.</p>
      <p><strong>1991 LPG Reforms:</strong> Liberalization, Privatization, and Globalization transformed India's trade and industrial policy.</p>
      <p><strong>Agricultural Policy:</strong> Issues surrounding Minimum Support Price (MSP), PM-KISAN (direct income support), and APMC reforms remain central to Indian development.</p>
      <p><strong>Demographic Dividend:</strong> Analyzing India's working-age population bulge and the necessity of job creation to harness this potential.</p>
    </article>
  );
};


